﻿/* 
Object:         Node
Description:    Logic and events for the module NodeRoles
Used in:        Node
*/

/*---[ ESLint ]---*/
/*
    global _msg_notsaved: true
*/

window.nodeRoles = function () {

    return {

        /**
        * Init noderoles
        * @param {string} notsaved
        */
        initialize: function (notsaved) {
            _msg_notsaved = notsaved;
        },

        /**
        * Return label changed not saved
        */
        Get_LDataChangedNotSavedYet: function () {
            return _msg_notsaved;
        },

        /**
        * Enable save button
        */
        enableSaveButton: function () {
            $("#saveButtonRoles").data("kendoButton").enable(true);
        },

        /**
        * Disable save button
        */
        disableSaveButton: function () {
            $("#saveButtonRoles").data("kendoButton").enable(false);
        },

        /**
        * roles - Left clicked
        */
        leftClicked: function () {
            nodeRoles.enableSaveButton();
            listbox.moveItems("Node_Roles_CplSelected", "Node_Roles_CplNotSelected", "#Roles_Validation", nodeRoles.Get_LDataChangedNotSavedYet);
        },

        /**
        * Tab roles - Right clicked
        */
        rightClicked: function () {
            nodeRoles.enableSaveButton();
            listbox.moveItems("Node_Roles_CplNotSelected", "Node_Roles_CplSelected", "#Roles_Validation", nodeRoles.Get_LDataChangedNotSavedYet);
        },

        /**
        * Tab roles - Save button clicked
        * @param {string} actionUrl
        * @param {number} nodeId
        */
        saveButtonClicked: function (actionUrl, nodeId) {

            nodeRoles.disableSaveButton();

            var json = $("#Node_Roles_CplSelected").data("kendoListBox").dataSource.view();
            var list = json.slice();

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { list: kendo.stringify(list), id: nodeId },
                success: function (responseData) {

                    $('#Roles_Validation').text("");

                    if (responseData.Success) {
                        // do nothing
                    } else {
                        $('#Node_Roles_CplNotSelected').data("kendoListView").dataSource.read();
                        $('#Node_Roles_CplSelected').data("kendoListView").dataSource.read();
                    }

                    var color = (responseData.Success ? 'green' : 'red');
                    $('#Roles_Validation').text(responseData.Message);
                    $('#Roles_Validation').attr('style', 'color:' + color);
                }
            });
        },
    }
}();